import { useFormik } from 'formik';
import React, { useState } from 'react';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { toast } from 'react-toastify';
import moment from 'moment';
import { authAxiosInstance } from '../../utils/axiosConfig';
import FormikAsyncSelect from '../../components/formik/FormikAsyncSelect';
import { fetchContacts } from '../../app/reducers/Contacts/contactsSlice';
import { useDispatch } from 'react-redux';
import { ClipLoader } from 'react-spinners';

const MillReportFromToForm = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            from: new Date('01/01/2023'),
            to: new Date(),
            vendorName: '',
            vendor: '',
        },
        onSubmit: async (values) => {
            console.log('values', values);
            if (!values?.from && !values?.to) {
                toast.error('Please select From and To date');
                return;
            }
            if (values?.from && !values?.to) {
                toast.error('Please also select To date');
                return;
            }
            if (!values?.from && values?.to) {
                toast.error('Please also select From date');
                return;
            }

            const data = {
                fromDate: moment(values?.from).startOf('day').valueOf(),
                endDate: moment(values?.to).endOf('day').valueOf(),
            };
            if (values?.vendor) {
                data['vendor'] = formik.values.vendor;
            }
            try {
                setLoading(true);
                const response = await authAxiosInstance.post(
                    '/millDispatch/millReport',
                    data
                );
                const printWindow = window.open('', '_blank');
                printWindow.document.write(response.data);
                setLoading(false);
            } catch (error) {
                console.log('error', error);
                toast.error('Failed to get mill report');
            } finally {
                setLoading(false);
            }
        },
    });
    return (
        <div className="p-4 border rounded-lg">
            <h1 className="font-semibold">Mill Pending Report</h1>
            <form className="w-full" onSubmit={formik.handleSubmit}>
                <div className="w-full mt-1 mb-1">
                    <FormikAsyncSelect
                        name="vendor"
                        label="Mill Vendor"
                        formik={formik}
                        getOptions={async (value) => {
                            const action = await dispatch(
                                fetchContacts({
                                    search: value,
                                    contact_type: 'vendor',
                                })
                            );
                            const serverResp = action.payload.contacts.map(
                                (ele) => ({
                                    label: `${ele.contact_name}`,
                                    value: `${ele.contact_id}/${ele.contact_name}`,
                                })
                            );
                            return serverResp;
                        }}
                        onChange={(option) => {
                            const id = option.value.split('/')[0];
                            const vendor_name = option.value.split('/')[1];
                            formik.setFieldValue('vendorName', vendor_name);
                            formik.setFieldValue('vendor', id);
                        }}
                    />
                </div>
                <div className="flex flex-row items-center gap-4">
                    <div className="w-full">
                        <FormikInputDateGroup
                            formik={formik}
                            name="from"
                            label="From"
                        />
                    </div>
                    <div className="w-full">
                        <FormikInputDateGroup
                            formik={formik}
                            name="to"
                            label="To"
                        />
                    </div>
                </div>
                <div className="mt-4 flex flex-row items-center gap-4">
                    {loading ? (
                        <ClipLoader />
                    ) : (
                        <PrimaryButton type="submit">Get Report</PrimaryButton>
                    )}
                    <PrimaryButton
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            formik.setFieldValue('from', '');
                            formik.setFieldValue('to', '');
                            formik.setFieldValue('vendor', '');
                            formik.setFieldValue('vendorName', '');
                        }}
                    >
                        Clear
                    </PrimaryButton>
                </div>
            </form>
        </div>
    );
};

export default MillReportFromToForm;
